import { render, staticRenderFns } from "./domainSetting.vue?vue&type=template&id=17e02de0&scoped=true&"
import script from "./domainSetting.vue?vue&type=script&lang=js&"
export * from "./domainSetting.vue?vue&type=script&lang=js&"
import style0 from "./domainSetting.vue?vue&type=style&index=0&id=17e02de0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e02de0",
  null
  
)

export default component.exports